import React from 'react'
import CounterButton from './counterButton'
import { defaultGuestValues } from '../redux/formSchema'

function GuestNumberPicker({
  minValue = 1,
  maxValue = 4,
  label = 'Guests',
  numGuestsField,
  guestsField
}) {
  function incrementRoom() {
    guestsField.addField(defaultGuestValues)
  }

  function decrementRoom() {
    guestsField.removeField()
  }

  return (
    <CounterButton
      minValue={minValue}
      maxValue={maxValue}
      value={numGuestsField.value}
      onChange={numGuestsField.onChange}
      label={label}
      onIncrement={incrementRoom}
      onDecrement={decrementRoom}
    />
  )
}

export default GuestNumberPicker



// WEBPACK FOOTER //
// ./src/components/guestNumberPicker.js